import { KeyboardEvent, Ref } from 'react';
import { GetInputPropsOptions, PropGetters } from 'downshift';
import { IDropdownItem } from '../../DropdownList';
import { Input } from '../../Input';
import { SearchInputClearWrap } from '../../Search/SearchInputClearWrap';

interface IAutoSuggestMainProps {
	getInputProps: PropGetters<IDropdownItem>['getInputProps'];
	isOpen: boolean;
	clearSelection: () => void;
	onKeyUp?: (event: KeyboardEvent<HTMLInputElement>) => void;
	placeholder?: string;
	ariaLabel?: string;
	disabled?: boolean;
	required?: boolean;
	invalid?: boolean;
	placeholderAsLabel?: boolean;
	onClearSearch?: () => void;
}

interface IGetInputPropsOptionsRef extends GetInputPropsOptions {
	ref?: Ref<HTMLInputElement>;
}

export function AutoSuggestMain({
	getInputProps,
	placeholder,
	ariaLabel,
	clearSelection,
	onKeyUp,
	disabled,
	invalid,
	required,
	placeholderAsLabel,
	onClearSearch,
}: IAutoSuggestMainProps) {
	const { value } = getInputProps();
	const showClearIcon =
		Array.isArray(value) || typeof value === 'string'
			? value?.length > 0
			: false;

	const clickHandler = () => {
		if (onClearSearch) {
			onClearSearch();
		}

		clearSelection();
	};

	return (
		<SearchInputClearWrap
			onClickClear={clickHandler}
			showClearIcon={!disabled && showClearIcon}
		>
			<Input
				disabled={disabled}
				invalid={invalid}
				aria-invalid={invalid}
				placeholder={placeholder}
				{...(getInputProps({ onKeyUp }) as IGetInputPropsOptionsRef)}
				aria-labelledby={undefined}
				aria-label={ariaLabel}
				required={required}
				placeholderAsLabel={placeholderAsLabel}
			/>
		</SearchInputClearWrap>
	);
}
